import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FNCO_PRE_MARKETING_LEGACY_CSS } from './legacyCss';

/** 레거시 CSS 를 이 루트 아래로 한정 — 레거시 조회 화면이 주던 부트스트랩 유틸만 보충 */
export const FncoPreMarketingRoot = styled(Box)`
  font-size: 16px;
  color: var(--dk-text-primary, #333);
  & .pt-10 {
    padding-top: 10px;
  }
  & .pb-10 {
    padding-bottom: 10px;
  }
  & .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
  & .table > tbody > tr > td {
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid var(--dk-line-strong, #ddd);
  }
  & .table-fixed {
    table-layout: fixed;
  }
  & hr {
    box-sizing: content-box;
    height: 0;
  }
  ${FNCO_PRE_MARKETING_LEGACY_CSS}
`;
